export default __webpack_public_path__ + "static/pipefy-footer-b43f8a0649a3f619fd2747bc4b59992f.png";